export enum FAMILY_ROUTES {
  GET_ALL = "/families",
  GET = "/families/",
  CREATE = "/families",
  UPDATE = "/families/",
  REMOVE = "/families/",
  ADD_MEMBER = "/families/",
  REMOVE_MEMBER = "/families/",
  GET_BALANCE = "/families/",
}
